import React from 'react';

import { appMethod as app } from '@utils/app';
import utils from '@utils/util';
import { transformPx2Rem, convertStyleData } from '@utils/tools';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './PresellCustomComponent.less';

/**
 * type：'presell'
 * 组件：预售组件
 */
export default class PresellCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let component_params = {
      page: 1,
      page_size: 10
    };
    let newdata = {};
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].loading'] = false;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    this.loadPresellList(compindex, component_params);
  }

  loadPresellList = (compindex, component_params) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let loadingNum = customFeature.loadingNum || 10;

    if (compData.is_more == 0 || compData.loading) {
      return;
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    if (component_params.page == 1) {
      newdata['eles[' + compindex + '].goods_data'] = [];
    }
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex] && component_params.page == 1) {
      let downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (let i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    pageInstance.setData(newdata);
    component_params.page_size = loadingNum;
    if (customFeature.source && customFeature.source != 'none') {
      component_params.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      }
    }

    pageInstance.setData({
      'loading': true
    });

    app.sendRequest({
      url: '/index.php?r=AppPreSell/GetPreSellGoodsList',
      data: component_params,
      method: 'post',
      success: res => {
        if (res.data) {
          let rdata = res.data,
            activity_info = res._presell_activity,
            final_payment_start_time = activity_info && activity_info.final_payment_start_time,
            newdata = {},
            downcountArr = pageInstance.downcountObject && pageInstance.downcountObject[compindex] || [],
            length = compData.goods_data.length || 0,
            matchReg = /CN_.*?\.mtl/gi;
          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i],
              newdata = {},
              dc,
              form_data = f.form_data,
              server_time = form_data.server_time || (Date.parse(new Date()) / 1000),
              acid = form_data.presell_activity_id,
              activity = res._presell_activity[acid],
              presell_goods = form_data._presell_goods,
              start_time = activity && activity.bargain_start_time * 1,
              _presell_discount_info = form_data._presell_discount_info == null ? [] : form_data._presell_discount_info[0],
              end_time = activity && activity.bargain_end_time * 1;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00',
              days: '00'
            };

            f.final_payment_start_time = utils.formatTimeYMD(new Date(activity && activity.final_payment_start_time * 1000), 'MM月DD日 hh:mm');
            var param_str = {
              goods_id: form_data.goods_id,
              activity_id: form_data.presell_activity_id || '',
              model_id: form_data.model_id || '',
              nums: 1,
              address_id: f.address_id || '',
              models_text: f.model_value_str || '',
              models_stock: _presell_discount_info.presell_stock,
              final_payment_start_time: f.final_payment_start_time || '',
              bargain_order_id: '',
              presell_status: f.presell_status || 0,
              limit_buy: _presell_discount_info.buy_limit_num
            }
            f.param_str = JSON.stringify(param_str);
            f.presellprice = {
              integer: typeof (presell_goods.presell_min_price) == 'string' && presell_goods.presell_min_price.match(/(\S*)./)[1] ? presell_goods.presell_min_price.match(/(\S*)./)[1] : presell_goods.presell_min_price,
              zero: typeof (presell_goods.presell_min_price) == 'string' && presell_goods.presell_min_price.match(/.(\S*)/)[1] ? presell_goods.presell_min_price.match(/.(\S*)/)[1] : '00'
            };
            f.model_length = f.form_data.goods_model ? f.form_data.goods_model.length : 0;
            f.server_time = server_time;
            f.seckill_end_time = utils.formatTime(new Date(end_time * 1000));
            f.seckill_start_time = utils.formatTime(new Date(start_time * 1000));
            f.status = server_time > start_time ? (server_time > end_time ? 2 : 3) : 0;
            if (f.status == 0) {
              dc = app.beforeGroupDownCount(f, pageInstance, 'eles[' +compindex + ']goods_data[' + (i + length) + ']');
            } else if (f.status == 3) {
              dc = app.duringGroupDownCount(f, pageInstance, 'eles[' +compindex + ']goods_data[' + (i + length) + ']');
            }
            dc && downcountArr.push(dc);
            f.form_data.price = form_data.virtual_price == '0.00' ? _presell_discount_info.origin_goods_price : form_data.virtual_price;
          }
          newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(rdata);
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    })
  }

  catchMorePresellList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let curpage = compData.curpage + 1;
    let goods_data = compData.goods_data || [];
    if (compData.loading || !compData.is_more) {
      return;
    }
    let component_params = {
      page: curpage,
      page_size: customFeature.loadingNum || 10
    }
    // if (compData.loading || !compData.is_more) {
    //   return;
    // }
    this.loadPresellList(compindex, component_params)
  }

  showOverTips = (e) => {
    app.showModal({
      content: '预售活动已结束'
    })
  }

  gotoPresellDetail = (e) => {
    var dataset = e.currentTarget.dataset,
      pageInstance = app.getAppCurrentPage(),
      franchisee = pageInstance.franchiseeId;
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('/presell/pages/presellDetail/presellDetail?detail=' + dataset.goodsid + chainParam)
  }

  payPresell = (e) => {
    var dataset = e.currentTarget.dataset,
      pageInstance = app.getAppCurrentPage(),
      franchisee = pageInstance.franchiseeId;
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.model > 0) {
      app.turnToPage('/presell/pages/presellDetail/presellDetail?detail=' + dataset.goodsid + chainParam)
    } else {
      var param_str = dataset.paramstr,
        pagePath = '/presell/pages/previewPresellOrder/previewPresellOrder?param=' + encodeURIComponent(param_str) + chainParam;
      app.turnToPage(pagePath);
    }
  }

  render() {
    const data = this.props.data;
    const { customFeature, goods_data } = data;
    const styleObj = convertStyleData(data.style);
    /**
     * @desc 商品列表样式
     */
    const goodsItemStyleObj = {
      height: transformPx2Rem(customFeature.lineHeight, 320),
      marginBottom: transformPx2Rem(customFeature.margin, 320),
      background: customFeature.lineBackgroundColor
    };

    const imgWrapStyleObj = {
      width: transformPx2Rem(customFeature.imgWidth, 320),
      height: transformPx2Rem(customFeature.imgHeight, 320)
    }

    /**
     * @desc mode为1、2、3的时候的列表
     */
    const ModeWrap = (props) => {
      const {
        className,
        colRowClassName,
      } = props;
      return (
        <div className={`presell-list ${className}`}>
          {
            !!goods_data && goods_data.map(item => (
              <div className="presell-goods-item isRelative"
                key={item.form_data.id}
                style={goodsItemStyleObj}
                data-goodsid={item.form_data.goods_id}
                data-activityid={item.form_data.activity_id}
                data-status={item.status}
                data-presellstatus={item.status}
                onClick={item.status != 4 ? this.gotoPresellDetail : this.showOverTips}>
                <div className="presell-image-wrap" style={imgWrapStyleObj}>
                  <img src={item.form_data.cover} />
                  {customFeature.isShowCountdown && item.status != 4 &&
                    <div className={`count-down ${item.status == 0 ? 'presell-not-begun' : 'pay-presell'}`}>
                      {item.status == 0
                        ? <React.Fragment>
                          距开始
                          <span>{item.downCount.days}天</span>
                          <span>{item.downCount.hours}</span> :
                          <span>{item.downCount.minutes}</span> :
                          <span>{item.downCount.seconds}</span>
                        </React.Fragment>
                        : <React.Fragment>
                          距结束
                          <span>{item.downCount.days}天</span>
                          <span>{item.downCount.hours}</span> :
                          <span>{item.downCount.minutes}</span> :
                          <span>{item.downCount.seconds}</span>
                        </React.Fragment>
                      }
                    </div>
                  }
                </div>
                <div className="presell-content-wrap">
                  <div className="presell-title">
                    {customFeature.isShowPresaleStatus && <div className={`presell-logo ${item.status == 0 ? 'presell-not-begun' : 'pay-presell'}`}>预售</div>}
                    {item.form_data.title}
                  </div>
                  <div className={`presell-detail-msg ${colRowClassName}`}>
                    {customFeature.isShowSales && customFeature.isShowVirtualPrice
                      ? <React.Fragment>
                        {(customFeature.mode == 1 || customFeature.mode == 2) &&
                          <React.Fragment>
                            <div className="presell-first-line">
                              <div className="presell-price">
                                <label className="presell-price" style={{ color: item.status == 0 ? '#8262E8' : '#FF4D4F' }}>
                                  ¥<span className="presell-price-int">{item.form_data._presell_goods.presell_current_price}</span>
                                </label>
                                {customFeature.isShowVirtualPrice && <span className="presell-origin-price">¥{item.form_data.price}</span>}
                              </div>
                            </div>
                            <div className="presell-second-line">
                              {item.status != 0
                                ? <div className="presell-view-count">已售{item.form_data._presell_goods.bargain_payment_count}件</div>
                                : <div className="presell-view-count">{item.form_data._presell_goods.presell_goods_view_count}人浏览</div>
                              }
                              <div className="presell-status-btn">
                                {item.status == 0 && <label className="presell-not-begun">未开售</label>}
                                {item.status == 3 && <label className="pay-presell"
                                                            data-paramstr={item.param_str}
                                                            data-goodsid={item.form_data.goods_id}
                                                            data-model={item.model_length}
                                                            onClick={(e) => {this.payPresell(e), e.stopPropagation()}}>付定金</label>}
                                {item.status != 0 && item.status != 3 && <label className="over-presell">已结束</label>}
                              </div>
                            </div>
                          </React.Fragment>
                        }
                        {customFeature.mode == 3 &&
                          <React.Fragment>
                            <div className="presell-left-line">
                              <div className="presell-price">
                                <label className="presell-price" style={{ color: item.status == 0 ? '#8262E8' : '#FF4D4F'}}>
                                  ¥<span className="presell-price-int">{item.form_data._presell_goods.presell_current_price}</span>
                                </label>
                                {customFeature.isShowVirtualPrice && <span className="presell-origin-price" style={{ marginLeft: '.1rem' }}>¥{item.form_data.price}</span>}
                              </div>
                              {customFeature.isShowSales &&
                                <React.Fragment>
                                  {item.status != 0
                                    ? <div className="presell-view-count">已售{item.form_data._presell_goods.bargain_payment_count}件</div>
                                    : <div className="presell-view-count">{item.form_data._presell_goods.presell_goods_view_count}人浏览</div>
                                  }
                                </React.Fragment>
                              }
                            </div>
                            <div className="presell-right-line">
                              <div className="presell-status-btn">
                                {item.status == 0 && <label className="presell-not-begun">未开售</label>}
                                {item.status == 3 && <label className="pay-presell"
                                                            data-paramstr={item.param_str}
                                                            data-goodsid={item.form_data.goods_id}
                                                            data-model={item.model_length}
                                                            onClick={(e) => {this.payPresell(e), e.stopPropagation()}}>付定金</label>}
                                {item.status != 0 && item.status != 3 && <label className="over-presell">已结束</label>}
                              </div>
                            </div>
                          </React.Fragment>
                        }
                      </React.Fragment>
                      : <React.Fragment>
                        <div className="presell-left-line">
                          {customFeature.isShowSales && item.status != 0
                            ? <React.Fragment>
                              <div className="presell-pricecustomFeature." style={customFeature.mode == 3 ? {display: 'inline-block'}: {}}>
                                <label className="presell-price" style={{ color: item.status == 0 ? '#8262E8' : '#FF4D4F' }}>
                                  ¥<span className="presell-price-int">{item.form_data._presell_goods.presell_current_price}</span>
                                </label>
                                {customFeature.isShowVirtualPrice && <span className="presell-origin-price">¥{item.form_data.price}</span>}
                              </div>
                              {customFeature.isShowSales &&
                                <React.Fragment>
                                  {item.status != 0
                                    ? <div className="presell-view-count" style={customFeature.mode == 3 ? {display: 'inline-block', marginLeft: '.1rem'} : {marginTop: '.2rem'}}>
                                      已售{item.form_data._presell_goods.bargain_payment_count}件
                                    </div>
                                    : <div className="presell-view-count" style={customFeature.mode == 3 ? {display: 'inline-block'} : {marginTop: '.2rem'}}>
                                      {item.form_data._presell_goods.presell_goods_view_count}人浏览
                                    </div>
                                  }
                                </React.Fragment>
                              }
                            </React.Fragment>
                            : <React.Fragment>
                              <div className="presell-price" style={customFeature.mode == 3 ? {display: 'inline-block'} : {}}>
                                <label className="presell-price" style={{ color: item.status == 0 ? '#8262E8' : '#FF4D4F' }}>
                                  ¥<span className="presell-price-int">{item.form_data._presell_goods.presell_current_price}</span>
                                </label>
                              </div>
                              {customFeature.isShowVirtualPrice && <div className="presell-origin-price" style={customFeature.mode == 3 ? {display: 'inline-block', marginLeft: '.1rem'} : {}}>¥{item.form_data.price}</div>}
                            </React.Fragment>
                          }
                        </div>
                        <div className="presell-right-line">
                          <div className="presell-status-btn">
                            {item.status == 0 && <label className="presell-not-begun">未开售</label>}
                            {item.status == 3 && <label className="pay-presell"
                                                        data-paramstr={item.param_str}
                                                        data-goodsid={item.form_data.goods_id}
                                                        data-model={item.model_length}
                                                        onClick={(e) => {this.payPresell(e), e.stopPropagation()}}>付定金</label>}
                            {item.status != 0 && item.status != 3 && <label className="over-presell">已结束</label>}
                          </div>
                        </div>
                      </React.Fragment>
                    }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      )
    }

    // 是否为竖版
    const hor = customFeature.mode == 2 && data.curpage > 0;
  
    return <ScrollView
      className={`custom-component presell presell-list-mode-${customFeature.mode} ${(customFeature.mode == 2 && data.curpage > 0) ? 'hor-request-status' : ''}`}
      data-compindex={this.props.index}
      data-type="presell-list"
      style={styleObj}
      scroll-y={ (customFeature.mode == 2 || customFeature.vesselAutoheight != 0) ? false : true }
      scroll-x={ customFeature.mode == 2 ? true : false }
      lower-threshold="100"
      bindscrolltolower={this.catchMorePresellList}
      // bindanimationend="animationEnd"
      >
      {
        customFeature.mode == 0 &&
        <div className="presell-list list">
          {
            !!goods_data && goods_data.map(item => (
              <div className="presell-goods-item isRelative"
                key={item.form_data.id}
                style={goodsItemStyleObj}
                data-goodsid={item.form_data.goods_id}
                data-activityid={item.form_data.group_buy_activity_id}
                data-status={item.status}
                data-presellstatus={item.status}
                onClick={item.status != 4 ? this.gotoPresellDetail : this.showOverTips}>
                <div>
                  <div className="presell-image-wrap" style={imgWrapStyleObj}>
                    <img src={item.form_data.cover} />
                  </div>
                  <div className="presell-content-wrap">
                    <div className="presell-title">
                      {
                        customFeature.isShowPresaleStatus &&
                        <div className={`presell-logo ${item.status == 0 ? 'presell-not-begun' : 'pay-presell'}`}>预售</div>
                      }
                      {item.form_data.title}
                    </div>
                    <div className="presell-detail-msg">
                      <div className="first-line">
                        <div className="presell-price">
                          <label className="presell-price" style={{ color: item.status == 0 ? '#8262E8' : '#FF4D4F' }}>
                            ¥<span className="presell-price-int">{item.form_data._presell_goods.presell_current_price}</span>
                          </label>
                          {customFeature.isShowVirtualPrice && <span className="presell-origin-price">¥{item.form_data.price}</span>}
                        </div>
                        <div className="presell-status-btn">
                          {
                            item.status == 0 &&
                            <label className="presell-not-begun">未开售</label>
                          }
                          {
                            item.status == 3 && 
                            <label className="pay-presell"
                              data-paramstr={item.param_str}
                              data-goodsid={item.form_data.goods_id}
                              data-model={item.model_length}
                              onClick={(e) => {this.payPresell(e), e.stopPropagation()}}
                              >付定金</label>
                          }
                          {
                            item.status != 0 && item.status != 3 &&
                            <label className="over-presell">已结束</label>
                          }
                        </div>
                      </div>
                      <div className="second-line">
                        {customFeature.isShowSales &&
                          <React.Fragment>
                            {item.status != 0
                              ? <span className="presell-view-count">已售{item.form_data._presell_goods.bargain_payment_count}件</span>
                              : <span className="presell-view-count">{item.form_data._presell_goods.presell_goods_view_count}人浏览</span>
                            }
                          </React.Fragment>
                        }
                        {customFeature.isShowCountdown && item.status != 4 &&
                          <React.Fragment>
                            {item.status == 0
                              ? <span className="pull-right" style={{ color: '#8262E8' }}>距开始：{item.downCount.days}天{item.downCount.hours}:{item.downCount.minutes}:{item.downCount.seconds}</span>
                              : <span className="pull-right" style={{ color: '#FF4D4F' }}>距结束：{item.downCount.days}天{item.downCount.hours}:{item.downCount.minutes}:{item.downCount.seconds}</span>
                            }
                          </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      }
      {
        customFeature.mode == 1 &&
        <ModeWrap className="opposite" colRowClassName={(!customFeature.isShowSales || !customFeature.isShowVirtualPrice) ? 'col' : 'row'}></ModeWrap>
      }
      {
        customFeature.mode == 2 &&
        <ModeWrap className="swiper" colRowClassName={(!customFeature.isShowSales || !customFeature.isShowVirtualPrice) ? 'col' : 'row'}></ModeWrap>
      }
      {
        customFeature.mode == 3 &&
        <ModeWrap className="bigPicture" colRowClassName=""></ModeWrap>
      }
      {/* 加载loading */}
      {
        data.loading && 
        <RequestStatus is="requestLoading" hor={hor}></RequestStatus>
      }
      {/* 加载没有数据 */}
      {
        data.is_more == 0 && data.goods_data.length == 0 &&
        <RequestStatus is="requestNone" data={{ data: '暂无商品'}} hor={hor}></RequestStatus>
      }
      {/* 加载失败 */}
      {
        data.loadingFail &&
        <RequestStatus is="requestFail" data={{refreshEvent: 'catchMorePresellList', compindex: this.props.index}} hor={hor}></RequestStatus>
      }
      {/* 加载完所有数据 */}
      {
        data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText &&
        <RequestStatus is="requestAll" hor={hor}></RequestStatus>
      }
      {/* 点击加载按钮 */}
      {
        data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
        <LoadingBtn customFeature={customFeature} onClick={this.goodsScrollFunc} data-compindex={this.props.index}></LoadingBtn>
      }
    </ScrollView>
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/presell-custom-component/PresellCustomComponent.jsx